/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2013                             *
 *                                                     *
 *******************************************************/

//Product Content object
class ProductContent {
  id;
  description;
  supplement;
  numberItems;
  price;
  discount;

  constructor (id, description, supplement, numberItems, price, discount){
    this.id=id;
    this.description=description;
    this.supplement=supplement;
    this.numberItems=parseInt(numberItems);
    this.price=parseFloat(price);
    this.discount=parseFloat(discount);
  }

  /*set numberItems(num) {
    this.numberItems = parseInt(num);
  }
  set price(price) {
    this.price = parseFloat(price);
  }
  set discount(discount) {
    this.discount = parseFloat(discount);
  }*/

  addItems(value) {
    this.numberItems+=parseInt(value);
  }

  removeItems(value) {
    this.numberItems-=parseInt(value);
  }
};

//Product object
class Product{
  id;
  name;
  description;
  type;
  date;
  excursion_id;
  language;
  specialexcursion;
  contents={};

  constructor (id, name, description, type, date, excursion_id, language, specialexcursion, hotel){
    this.id=id;
    this.name=name;
    this.description=description;
    this.type=type;
    this.date=date;
    this.excursion_id=excursion_id;
    this.language=language;
    this.specialexcursion=specialexcursion;
    this.hotel=hotel;
  }

  addContent (content) {
    this.contents['contentid_'+content.id]=content;
  }

  getContent (idcontent) {
    return this.contents['contentid_'+idcontent];
  }

  deleteContent (idcontent) {
    delete this.contents['contentid_'+idcontent];
  }

  deleteAllContent () {
    this.contents={};
  }

  existContent (idcontent) {
    return this.contents.hasOwnProperty('contentid_'+idcontent);
  }

  getNumContents () {
    return Object.keys(this.contents).length;
  }

};

export default class EMDBcart {

  #storagename  = "emdbcart";
  #cartProducts = {};

  //Privates

  //Return Product of cart
  #getProduct(idproduct) {
    if (this.#cartProducts.hasOwnProperty('productid_'+idproduct)) return this.#cartProducts['productid_'+idproduct];
    else return null;
  }

  //Delete Product of cart
  #deleteProduct(idproduct) {
    if (this.#cartProducts.hasOwnProperty('productid_'+idproduct)) delete this.#cartProducts['productid_'+idproduct];
  }

  //Convert JSON to Cart Object
  #parse(object) {
    let products = {};
    for (let product in object){
      products[product]=new Product(object[product].id, object[product].name, object[product].description, object[product].type, object[product].date, object[product].excursion_id, object[product].language, object[product].specialexcursion, object[product].hotel);
      for (let content in object[product].contents){
        products[product].addContent(new ProductContent(
          object[product].contents[content].id,
          object[product].contents[content].description,
          object[product].contents[content].supplement,
          object[product].contents[content].numberItems,
          object[product].contents[content].price,
          object[product].contents[content].discount));
      }
    }
    return products;
  }

  //Save cart in LocalStorage
  #setStorageCart() {
    sessionStorage.setItem(this.#storagename, JSON.stringify(this.#cartProducts));

    //Disparamos evento Storage para avisar a otros componentes
    document.dispatchEvent(new CustomEvent('storage'));
  }

  //Load cart From Localstorage
  #getStorageCart() {
    let value = sessionStorage.getItem(this.#storagename);
    let storageCart= value ? JSON.parse(value):{};
    this.#cartProducts = this.#parse(storageCart);
  }

  //--------------------------------------------------------------------------------------------------------------------
  //  Publics
  //--------------------------------------------------------------------------------------------------------------------

  constructor(value) {
    this.#storagename=value || "emdbcart";
    this.#getStorageCart();
  }

  deleteCart () {
    this.#cartProducts = {};
    this.#setStorageCart();
  }

  addProduct (idproduct, nameproduct, descriptionproduct, typeproduct, date, excursion_id, language, specialexcursion, hotel, idcontent, descriptioncontents, supplement, numberItems, price, discount) {
    //Si no esta el producto en el carro lo añadimos
    if (!this.#cartProducts.hasOwnProperty('productid_'+idproduct)){
      //Añadimos producto
      this.#cartProducts['productid_'+idproduct]=new Product(idproduct, nameproduct, descriptionproduct, typeproduct, date, excursion_id, language, specialexcursion, hotel);

      //Añadimos las caracteristica del producto
      this.#cartProducts['productid_'+idproduct].addContent(new ProductContent(idcontent, descriptioncontents, supplement, numberItems, price, discount));
    }else{
      if (!this.#cartProducts['productid_'+idproduct].existContent(idcontent)){
        //Añadimos las caracteristica del producto
        this.#cartProducts['productid_'+idproduct].addContent(new ProductContent(idcontent, descriptioncontents, supplement, numberItems, price, discount));
      }else{
        //Solo sumamos numero de items
        this.#cartProducts['productid_'+idproduct].contents['contentid_'+idcontent].addItems(numberItems);
      }
    }
    this.#setStorageCart();
  }

  deleteProduct (idproduct) {
    this.#deleteProduct(idproduct);
    this.#setStorageCart();
  }

  deleteAllProduct () {
    this.#cartProducts = {};
    this.#setStorageCart();
  }

  addProductContent (idproduct,idcontent,value) {
    if (this.#getProduct(idproduct).existContent(idcontent)) this.#getProduct(idproduct).getContent(idcontent).addItems(value);
    this.#setStorageCart();
  }

  removeProductContent (idproduct,idcontent,value) {
    if (this.#getProduct(idproduct).existContent(idcontent)){
      if (value < this.#getProduct(idproduct).getContent(idcontent).numberItems) this.#getProduct(idproduct).getContent(idcontent).removeItems(value);
      else{
        this.#getProduct(idproduct).deleteContent(idcontent);
        if (!this.#getProduct(idproduct).getNumContents()) this.deleteProduct(idproduct);
      }
    }
    this.#setStorageCart();
  }

  deleteProductContent (idproduct,idcontent) {
    this.#getProduct(idproduct).deleteContent(idcontent);
    if (!this.#getProduct(idproduct).getNumContents()) this.deleteProduct(idproduct);
    this.#setStorageCart();
  }

  getCartProducts () {
    return this.#cartProducts;
  }

  getCartProduct (idproduct) {
    return this.#getProduct(idproduct);
  }

  getNumProducts () {
    return Object.keys(this.#cartProducts).length;
  }

  getCartAmount () {
    let totaltamount=0;
    for (let productid in this.#cartProducts){
      for (let content in this.#cartProducts[productid].contents){
        totaltamount+=this.#cartProducts[productid].contents[content].price * this.#cartProducts[productid].contents[content].numberItems - this.#cartProducts[productid].contents[content].discount * this.#cartProducts[productid].contents[content].numberItems;
      }
    }
    return totaltamount;
  }

  getProductNumItemsNoSupplement (idproduct){
    let totalitems=0;
    let products=this.#getProduct(idproduct);
    if (products!=null){
      for (let content in products.contents){
        if(!this.#getProduct(idproduct).contents[content].supplement) totalitems+=this.#getProduct(idproduct).contents[content].numberItems;
      }
    }
    return totalitems;
  }

  refreshCart () {
    this.#getStorageCart();
  }

}




